import { lazy, Suspense } from 'react';
import { ImageViewerIAProps } from './interfaces';

// Lazy load ImageViewerIA to reduce initial bundle (includes Konva ~183KB gzip)
const ImageViewerIAComponent = lazy(() => import('./ImageViewerIA').then(mod => ({ default: mod.ImageViewerIA })));

// Fallback component while ImageViewerIA is loading
function ImageViewerIAFallback({ width = '100%', height = '500px' }: { width?: string | number; height?: string | number }) {
  return (
    <div 
      style={{ 
        width: typeof width === 'number' ? `${width}px` : width,
        height: typeof height === 'number' ? `${height}px` : height,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'rgba(0,0,0,0.05)',
        borderRadius: '4px'
      }}
    >
      <div className="text-center">
        <div className="spinner-border text-primary mb-2" role="status">
          <span className="visually-hidden">Loading AI image viewer...</span>
        </div>
        <div style={{ fontSize: '14px', opacity: 0.7 }}>Loading AI image viewer...</div>
      </div>
    </div>
  );
}

export function ImageViewerIALazy(props: ImageViewerIAProps) {
  return (
    <Suspense fallback={<ImageViewerIAFallback width={props.width} height={props.height} />}>
      <ImageViewerIAComponent {...props} />
    </Suspense>
  );
}

export default ImageViewerIALazy;
